import { Component } from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import { UserProvider } from '../../providers/user/user';
import { ToolsProvider } from '../../providers/tools/tools';
import { TripService } from '../../providers/trip-service/trip-service';
import { App, ModalController } from 'ionic-angular';
import { ConfigProvider } from '../../providers/config/config';
import { Capacitor } from '@capacitor/core';
import defaultServices from './default-services';

@Component({
  selector: 'services-dashboard',
  templateUrl: 'services-dashboard.html',
})
export class ServicesDashboardComponent {
  log = debug('app:ServicesDashboardComponent');

  subs: any = [];
  sponsorship = { advertiser: { logo: '' } };
  dashboardItems: {
    title: string;
    iconDisplay: string;
    opts: {
      tab?: number;
      page?: string;
      params?: any;
      externalUrl?: string;
    };
    onClick?: () => void;
  }[] = [];

  lcGiveAwayConfig;

  constructor(
    public user: UserProvider,
    public tools: ToolsProvider,
    public appCtrl: App,
    public modalCtrl: ModalController,
    public tripService: TripService,
    public configs: ConfigProvider
  ) {}

  ngOnInit() {
    this.lcGiveAwayConfig = this.configs.get(
      'sponsorship-live-chat-giveaway'
    );
    this.setDashboardItems();

    this.tripService.on('enroute', status => {
      this.setDashboardItems();
    });

    const sponsor = this.configs.get('sponsorship-command-center');
    if (_.get(sponsor, 'advertiser.logo')) {
      console.log('sponsor', sponsor.advertiser);
      this.sponsorship = sponsor;
      this.tools.logAnalyticsEvent('trackCustom', 'sponsorship-command-center');
    }
  }

  navTo(page, params: any = {}) {
    this.tools.navTo(page, 2, params);
  }

  onClick(opts: {
    tab: number;
    page: string;
    params: any;
    externalUrl: string;
  }) {
    if (opts.externalUrl) {
      this.tools.openExternalUrl(opts.externalUrl);
    } else {
      this.tools.navTo(opts.page, opts.tab, opts.params);
    }
    this.tools.logAnalyticsEvent(
      'trackCustom',
      'select-command-center-option',
      {
        commandCenter: opts,
      }
    );
  }

  private setDashboardItems() {
    this.dashboardItems =
      this.configs.get('home-services-dashboard-cards') || defaultServices;
    this.sortDashboardItems();
  }

  private sortDashboardItems() {
    this.dashboardItems.sort((a, b) => {
      if (a.title === 'Trip Planner' && this.tripService.info.isEnroute) {
        a.title = 'Active Trip';
      }

      if (a.title === 'Active Trip') {
        return -1;
      } else if (b.title === 'Active Trip') {
        return 1;
      } else {
        return 0;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/services-dashboard/services-dashboard.ts